import { MarketplaceSpecialistsSearchPage } from './SpecialistsSearchPage'

const SpecialistsSearchSavedProfiles = () => <MarketplaceSpecialistsSearchPage onlySavedProfiles />

export { SpecialistsSearchSavedProfiles }
